import React from "react";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
// import CallOutlinedIcon from "@mui/icons-material/CallOutlined";
import women from "../../assets/images/woman-sits-desk-with-laptop-word-apple-it.jpg";

export default function Aboutus() {
  const handleDownloadCV = () => {
    window.open("/Divyasri_Kandavalli_Resume.pdf", "_blank");

    const link = document.createElement("a");
    link.href = "/Divyasri_Kandavalli_Resume.pdf";
    link.download = "Divyasri_Kandavalli_Resume.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <section className="py-24 text-[#F8F8F8]" id="about">
      <div className="relative max-w-7xl mx-auto px-8 2xl:px-0 flex flex-col xl:flex-row items-center gap-20">
        {/* LEFT IMAGE BLOCK */}
        <div className="flex-1 flex justify-center order-2 xl:order-1">
          <div
            className="
      relative   w-[80%] h-[80%]
      xl:w-auto xl:h-auto
    "
          >
            {/* Profile Image */}
            <img
              src={women}
              alt="About Us"
              className="w-full h-full object-cover rounded-full relative "
            />

            {/* Glowing Green Ring */}
            <div className="absolute inset-[-25px] rounded-full border-[12px] border-[#C1FF75] opacity-80 z-10"></div>

            {/* Outer Decorative Arc */}
            <div
              className="
               hidden  xl:absolute inset-[-45px] rounded-full border-[3px] 
                border-white/10 border-l-transparent border-b-transparent
                rotate-[-25deg] z-0
              "
            ></div>
          </div>
        </div>

        {/* RIGHT CONTENT */}
        <div className="flex-1 order-1 xl:order-2 ">
          <ul className="list-none mb-4" data-aos="fade-up">
            <li className="text-[#F8F8F8] flex items-center before:content-[''] before:w-3 before:h-3 before:mr-2 before:bg-gradient-to-r before:from-[#6cfcb5] before:to-[#F0FF6C] before:rounded-full text-[16px] font-medium leading-[1.4em]">
              About Me
            </li>
          </ul>
          <h2
            className="text-[24px] md:text-[32px] xl:text-[42px] text-[#F8F8F8] font-semibold leading-[1.2em]"
            data-aos="fade-up"
          >
            Who is{" "}
            <span className="bg-gradient-to-r from-[#6cfcb5] to-[#F0FF6C] bg-clip-text text-transparent">
              Divya Sri ?
            </span>
          </h2>
          <p
            className="mt-4 text-[16px] md:text-[20px] font-semibold text-[#F8F8F8]"
            data-aos="fade-up"
          >
            Helping businesses grow with modern web development solutions.
          </p>

          <p
            className="mt-4 text-[#F8F8F8] text-[16px] leading-relaxed"
            data-aos="fade-up"
          >
            Hi, I’m Divya Sri, a passionate{" "}
            <span className="bg-gradient-to-r from-[#6cfcb5] to-[#F0FF6C] bg-clip-text text-transparent font-medium">
              MERN Stack Developer
            </span>{" "}
            who enjoys building scalable web applications and creating smooth
            user experiences. I focus on writing clean, efficient code and
            developing modern full-stack solutions.
          </p>

          <div className="flex flex-col md:flex-row justify-between items-start mt-8">
            {/* CONTACT SECTION */}
            <div className="mt-8 space-y-6 ">
              {/* Email */}
              <div className="flex items-center gap-4" data-aos="fade-up">
                <div className="flex items-center justify-center">
                  <MailOutlineIcon
                    sx={{
                      fontSize: 38,
                      fill: "url(#mailGradient)",
                    }}
                  />
                  <svg width="0" height="0">
                    <defs>
                      <linearGradient
                        id="mailGradient"
                        x1="0%"
                        y1="0%"
                        x2="100%"
                        y2="0%"
                      >
                        <stop offset="0%" stopColor="#6cfcb5" />
                        <stop offset="100%" stopColor="#F0FF6C" />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>

                <div>
                  <p className="text-[#F8F8F8] text-[14px] md:text-[16px]">
                    Email Us At
                  </p>
                  <a
                    href="mailto:divyasrikandavalli12@gmail.com"
                    className="text-[14px] md:text-[18px] lg:text-[20px] font-semibold"
                  >
                    divyasrikandavalli12@gmail.com
                  </a>
                </div>
              </div>

              {/* Phone */}
              {/* <div className="flex items-center gap-4" data-aos="fade-up">
                <div className="flex items-center justify-center">
                  <CallOutlinedIcon
                    sx={{
                      fontSize: 38,
                      fill: "url(#callGradient)",
                    }}
                  />

                  <svg width="0" height="0">
                    <defs>
                      <linearGradient
                        id="callGradient"
                        x1="0%"
                        y1="0%"
                        x2="100%"
                        y2="0%"
                      >
                        <stop offset="0%" stopColor="#6cfcb5" />
                        <stop offset="100%" stopColor="#F0FF6C" />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
                <div>
                  <p className="text-[#F8F8F8] text-[14px] md:text-[16px]">
                    Phone Number
                  </p>
                  <a
                    href="tel:+919110385435"
                    className="text-[14px] md:text-[18px] lg:text-[20px] font-semibold"
                  >
                    +91 9110385435
                  </a>
                </div>
              </div> */}
            </div>

            {/* EXPERIENCE + BUTTON */}
            <div className="mt-10 ">
              {/* Experience Box */}
              <div className="bg-white/10 backdrop-blur-sm py-[30px] px-[20px] rounded-2xl text-left">
                <h3 className="text-[60px] font-bold bg-gradient-to-r from-[#6cfcb5] to-[#F0FF6C] bg-clip-text text-transparent">
                  3+
                </h3>
                <p className="text-[#F8F8F8] font-medium text-[16px]">
                  Years Experience
                </p>
              </div>

              {/* Resume Button */}
              <button
                onClick={handleDownloadCV}
                className="
    px-8 py-4 text-white font-semibold 
    text-[16px]
  "
              >
                My Resume{" "}
                <span className="bg-gradient-to-r from-[#6cfcb5] to-[#F0FF6C] bg-clip-text text-transparent">
                  ✦
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
